define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"dojo/topic",
	"dojo/when",
	"dijit/layout/TabContainer",
	"designSystem/types/button-types",
	"underscore",
	"csi/action",
	"csi/def",
	"csi/def/Action",
	"csi/def/Context",
	"csi/html",
	"csi/locale",
	"csi/tabs/Widget",
	"csi/widget/Container",
	"csi/wizard/StepItem",
	"csi/wizard/StepData",
	"csi/xml",
	"./Content",
	"./FinishController",
	"./NextPageController",
	"./PrevPageController",
	"./StepSummaryItem",
	"dojo/text!csi/templates/wizard.html"
], function(array, declare, lang, Memory, topic, when, TabContainer, { ButtonEnum }, _, csiAction, def, Action, Context, html, locale, Widget, Container, StepItem, StepData, xml, Content, FinishController, NextPageController, PrevPageController, StepSummaryItem, template) {
	const {
		BUTTON_CANCEL,
		BUTTON_CANCEL_ALL,
		BUTTON_PREV_PAGE,
		BUTTON_NEXT_PAGE,
		BUTTON_FINISH,
		BUTTON_FINISH_GO,
		BUTTON_SAVE_NEW,
	} = ButtonEnum;

	csiAction.registerControllers("Wizard", {
		Finish: FinishController,
		NextPage: NextPageController,
		PrevPage: PrevPageController
	});

	return declare(Widget, {
		allowChildToScroll: true,
		baseClass: "wizardView",
		templateString: template,
		tabContainerClass: TabContainer,

		/** @property {Object} rightWidget - widget to appear on right side of form */
		// rightWidget: null,

		/** @property {Object} rightWidgetClass - widget class to appear on right side of form */
		// rightWidgetClass: null,

		/** @property {Object} rightWidgetNode - the container of an optional right widget */
		// rightWidgetNode: null,

		/** @property {Object} rightWidgetProperties - Properties of rightWidget */
		// rightWidgetProperties: null,

		// the container of the wizard
		//tabContainerNode: null,

		/** @property {boolean} hideNumberedStep - set to true, the left panel will be gone */
		hideNumberedStep: true,

		/** @property {Container} stepSummaryNode - the summary widget container of this wizard */
		stepSummaryNode: null,

		/** @property {number} stepIndex - the currently index of creating step */
		stepIndex: null,

		/** @property {Container} stepItemContainer - the step item widget container of this wizard */
		stepItemContainer: null,

		/** @property {StepData[]} stepList - the step data list of this wizard */
		stepList: null,

		addTab: function(/*Tab*/tab) {
			// summary: add page to wizard - uses different Content class than Tabs view and does not yet
			// support adding pages after being started
			var w = new Content({defTab: tab});
			this._collectStepData();
			this.tabsNode.addChild(w);
			return w;
		},

		/**
		 * Create the step widget items and add border for container
		 * */
		_buildView: function() {
			this.inherited(arguments);
			const {
				stepContainerNode
			} = this;

			if (this.hideNumberedStep) {
				html.setVisible(stepContainerNode, false);
				return;
			}

			// create summary information
			this._createSummaryItem();

			// create step information
			this._createStepItems(this.stepList);

			const container = this.getParent().containerNode;

			// only apply this styling to wizard dialog
			container.classList.add("csi-wizard-dialog");

			this._buildRightWidget();
		},

		/** build an optional right widget */
		_buildRightWidget: function() {
			if (this.rightWidgetClass && !this.rightWidget) {
				this.rightWidget = new this.rightWidgetClass(this.rightWidgetProperties).placeAt(this.rightWidgetNode);
			}
		},

		canEnableButton: function(/*Button*/button, /*String*/idAction) {
			// summary: return true or false indicating if button should be enabled based on current conditions
			var ac = this.getSourceController();
			var page = this.getSelectedPage();
			var index = this.getIndexOfPage(page);
			var disabled = false;

			switch (idAction) {
				case BUTTON_PREV_PAGE:
					disabled = ac.disablePrev(this, page, index);
					break;

				case BUTTON_NEXT_PAGE:
					disabled = ac.disableNext(this, page, index);
					break;

				case BUTTON_FINISH:
					disabled = ac.disableFinish(this, page, index);
					break;
			}

			return !disabled;
		},

		/**
		 * Return true if checkbox's page index and page index are same
		 * @param {ActionCheckboxConfig} config
		 * @return {boolean}
		 */
		canShowActionCheckbox: function(config) {
			var ac = this.getSourceController();
			var page = this.getSelectedPage();
			var index = this.getIndexOfPage(page);
			var realizedIndex = ac.getWizardRealizedPageIndex(this, index);

			if (config.pageIndex === null) {
				return true;
			}

			return config.pageIndex === realizedIndex;
		},

		canShowButton: function(/*String*/idAction) {
			// summary: return true or false indicating if button should be displayed based on current conditions
			var ac = this.getSourceController();
			var page = this.getSelectedPage();
			var index = this.getIndexOfPage(page);
			var realizedIndex = ac.getWizardRealizedPageIndex(this, index);

			if (idAction == BUTTON_PREV_PAGE) {
				return realizedIndex > 0;
			}

			var bLast = (realizedIndex == (ac.getWizardNumberOfRealizedPages(this) - 1));

			if (idAction == BUTTON_NEXT_PAGE) {
				// show next button on all but last page
				return !bLast;
			} else if (!this.defView.bShowFinishButton && (idAction == BUTTON_FINISH)) {
				// show finish button only on last page if so configured
				return bLast;
			} else if (idAction == BUTTON_FINISH_GO || idAction == BUTTON_SAVE_NEW) {
				// only show these Actions on the last page
				return bLast;
			} else if (idAction == BUTTON_CANCEL) {
				return !this._isCopyingNode();
			} else if (idAction == BUTTON_CANCEL_ALL) {
				return this._isCopyingNode();
			}

			return true;
		},

		/**
		 * Decide whether show the step pane or not
		 * @return {boolean}
		 */
		canShowStepPane: function() {
			// if any title is not configured, we treat it as non numbered step wizard, although, override this function to change the behavior
			return !this.stepList.some(stepData => !stepData.title);
		},

		carryOverFormData: function(/*Content*/sourcePage, /*Content*/targetPage) {
			// summary: carry the form data from the source page to the target page
			if (targetPage) {
				var formData = this.getFormDataFromPage(sourcePage, true);

				return this.setFormDataToPage(targetPage, formData);
			}

			return null;
		},

		/**
		 * Extension point to customize names in subtitle
		 * @param {string[]} names - node names to customize
		 */
		onPopulatePreviousSubtitle: function(names) {
			return names;
		},

		errorForm: function(/*String*/errMessage, /*String*/errCode) {
			// summary: display error on current page of wizard
			var view = this.getSelectedPage().getView();
			return view.errorForm(errMessage, errCode);
		},

		finishPage: function() {
			// summary: call onNextPage before finishing so controller can process page
			this.onNextPage(this.getSelectedPage(), this.getNextPage(), true);
		},

		getFormDataFromPage: function(/*Content*/page, /*Boolean*/lookInControllerIfMissing) {
			// summary: return form data from the page if it already exists.
			// If the form data doesn't exist on the page and 'lookInControllerIfMissing' is true,
			// look in the controller which opened this wizard
			var formData = (page && page.viewTab) ? page.viewTab.defView.m_formData : null;

			if (!formData && lookInControllerIfMissing) {
				var ac = this.getSourceController();
				if (ac) {
					formData = ac.getFormData();
				}
			}

			return formData;
		},

		getNextPage: function(/*Content?*/fromPage) {
			var index = this.getIndexOfPage(fromPage || this.getSelectedPage());
			++index;
			return this.getPageAt(index);
		},

		getIndexOfPage: function(/*Content?*/page) {
			return array.indexOf(this.getPages(), page);
		},

		getPageAt: function(/*Number*/index) {
			var children = this.getPages();
			return (index < 0 || index >= children.length) ? null : children[index];
		},

		getPages: function() {
			return this.tabsNode.getChildren();
		},

		getPrevPage: function(/*Content?*/fromPage) {
			var index = this.getIndexOfPage(fromPage || this.getSelectedPage());
			--index;
			return this.getPageAt(index);
		},

		getSelectedPage: function() {
			// summary: returns the currently selected Content
			return this.tabsNode.selectedChildWidget;
		},

		nextPage: function(/*Content?*/fromPage) {
			// summary: allow action controller to determine next page in wizard
			var nextPage = this.getNextPage(fromPage || this.getSelectedPage());
			var dfd = this.onNextPage(this.getSelectedPage(), nextPage, false);

			return when(dfd,
				(result) => {
					if (result !== false) {
						// only change to next page if page is after currently selected page - if you skip
						// from page 1 to page 4, then this will be called twice, once where next page is 4
						// and current page is 1, and then a second time where next page is 3 and the selected
						// page is 4. This check is here to skip that second time so we really end up at page 4.
						if (this.getIndexOfPage(nextPage) > this.getIndexOfPage(this.getSelectedPage())) {
							this._onChangePage(nextPage);
						}
					}

					this.onPostNextPage(nextPage);

					return result;
				},
				(err) => {
					return err;
				}
			);
		},

		onNextPage: function(/*Content*/currentPage, /*Content*/nextPage, /*Boolean*/bFinish) {
			// summary: invoke callbacks
			return this.getSourceController().onNextPage(this, currentPage, nextPage, bFinish);
		},

		onPrevPage: function(/*Content*/currentPage, /*Content*/prevPage) {
			// summary: invoke callbacks
			return this.getSourceController().onPrevPage(this, currentPage, prevPage);
		},

		/**
		 * Navigate the page
		 * @param {number} selectedIndex
		 */
		onSelectStep: function(selectedIndex) {
			const currentIndex = this.getIndexOfPage(this.getSelectedPage())

			if (selectedIndex == currentIndex) {
				return;
			}

			const moveForward = selectedIndex > currentIndex;

			// don't allow moving forward due to the validation for the intermediate steps
			if (moveForward) {
				return;
			}

			const targetPage = this.getPageAt(selectedIndex + 1);

			csiAction.invoke(this, targetPage, lang.mixin(new Action(), {
				classController: "csi/wizard/PrevPageController",
				classControllerParams: {
					fromPage: targetPage
				}
			}));
		},

		/**
		 * extension point
		 * @param {Widget} wizard
		 * @param {Widget} currentPage
		 */
		onPostNextPage: function(currentPage) {
			return this.getSourceController().onPostNextPage(this, currentPage);
		},

		/**
		 * bring to next page through the proxy action rather than user clicks
		 */
		proxyNextPage: function() {
			csiAction.invoke(this, this.domNode, lang.mixin(new Action(), {
				classController: "csi/wizard/NextPageController",
			}));
		},

		prevPage: function(/*Content?*/fromPage) {
			// summary: allow action controller to determine previous page in wizard
			var prevPage = this.getPrevPage(fromPage || this.getSelectedPage());
			var dfd = this.onPrevPage(this.getSelectedPage(), prevPage);
			var self = this;

			return when(dfd,
				function(result) {
					if (result !== false) {
						// see comment in nextPage for logic here
						if (self.getIndexOfPage(prevPage) < self.getIndexOfPage(self.getSelectedPage())) {
							self._onChangePage(prevPage);
						}
					}

					return result;
				},
				function(err) {
					return err;
				}
			);
		},

		setFormDataToPage: function(/*Content*/page, /*FormData*/formData, /*Boolean*/bRefreshPage, /*Object*/params) {
			// summary: set form data for given page and return deferred object if refreshing
			var view = page.viewTab;

			if (!this.hideNumberedStep) {
				// populate the subtitle in the previous step card
				this._populatePreviousSubtitle();
			}

			// reset tab root node - also reset form data so that form data itself does not get reset
			if (view) {
				view.defView.setFormData(null);
			}

			// make sure the formData's node is in the wizard's cache before calling 'refreshTab'
			var node = formData.getNode();
			this.cacheView.put(node);

			// create view for page
			var ctx = new Context(this, formData.getCache());
			ctx.setNode(node);
			page.refreshTab(ctx);

			// this code relies on special code in csi/view/Widget::_insertView to transfer formData to csi/def/View
			params = params || {};
			params.formData = formData;
			view = page.getView(this, params);

			return page.createView(this, bRefreshPage);
		},

		/**
		 * Set up introduction node for wizard
		 * @param {string} content
		 */
		setWizardIntroNode: function(content) {
			const {introNode} = this;

			if (!content) {
				html.setVisible(introNode, false);
				return;
			}

			html.setVisible(introNode, true);
			html.clear(introNode);
			html.multiLineText(introNode, content);
		},

		skipToNextPage: function(/*Content*/page) {
			// summary: skip over page, returning deferred from processing next page rather than this page;
			return this.nextPage(page);
		},

		skipToPrevPage: function(/*Content*/page) {
			// summary: skip over page, returning deferred from processing previous page rather than this page
			return this.prevPage(page);
		},

		validateForm: function(/*Object*/errorParams) {
			// summary: validate current page of wizard
			var view = this.getSelectedPage().getView();
			return view.validateForm(errorParams);
		},

		_buildTab: function(/*Content*/page) {
			// summary: pre-process first page before creating view; onNextPage should return deferred if switching
			// to another tab; if not, then create view on current tab (createView will not be triggered because tab
			// is already selected)
			var dfd;
			this.hideNumberedStep = !this.canShowStepPane();

			if (page) {
				dfd = this.onNextPage(null, page, false) || page.createView(this);
				this._updateWizardPage(page);
			}

			this.when(dfd, lang.hitch(this, this._postView));
		},

		/**
		 * Collect the step data for this wizard
		 * */
		_collectStepData: function() {
			let {
				stepIndex
			} = this;

			if (!stepIndex) {
				stepIndex = this.stepIndex = 0;
			}

			const sourceController = this.getSourceController();
			const res = sourceController.idWizardResource;

			const getResourceString = (res, suffix, index) => {
				let finalResourceId;
				if (res) {
					finalResourceId = res.concat(suffix).concat(index);
					return locale.resourceIfExists(finalResourceId);
				} else {
					finalResourceId = suffix.concat(index);
					return sourceController.getString(finalResourceId);
				}
			};

			const title = getResourceString(res, csiAction.SUFFIX_TITLE, stepIndex);
			const subTitle = getResourceString(res, csiAction.SUFFIX_SUBTITLE, stepIndex);
			const detail = getResourceString(res, csiAction.SUFFIX_DETAIL, stepIndex);

			const stepData = new StepData({
				index: stepIndex,
				detail,
				title,
				subTitle
			});

			if (!this.stepList) {
				this.stepList = [];
			}

			this.stepList.push(stepData);
			this.stepIndex++;
		},

		/**
		 * Add step information based on the step list
		 * @param {{StepData[]}} list
		 * */
		_createStepItems: function(list) {
			const {stepContainerNode} = this;
			let data = [];

			// add steps
			list.forEach((stepData, index) => {
				const {
					title,
					subTitle
				} = stepData;

				data.push({
					index,
					title: `${index + 1}. ${title}`,
					subTitle
				});
			});

			const store = new Memory({data});

			const c = this.stepItemContainer = new Container({
				store,
				widgetClass: StepItem,
				widgetProperties: StepItem.widgetProperties,
			}).placeAt(stepContainerNode);

			c.startup();
		},

		/**
		 * create the summary indicator & step action if configured
		 */
		_createSummaryItem: function() {
			if (!this._isCopyingNode()) {
				return;
			}

			const ac = this.getSourceController();

			const {stepContainerNode} = this;

			const node = this.getViewNode();
			const {
				$Name,
				$Type,
			} = node;

			const {
				_sourceSelectedLength,
				_sourcesToCheck,
			} = ac;

			const current = _sourceSelectedLength - _sourcesToCheck.length;

			// render the step action if configured
			const action = ac.getWizardStepAction(this, node);

			// initialize the summary
			new StepSummaryItem({
				action,
				type: $Type,
				name: $Name,
				count: locale.resource("ProgressIndicator", [current, _sourceSelectedLength]),
			}).placeAt(stepContainerNode);
		},

		/**
		 * Get the corresponding step card widget by the index given
		 * @param {number} index
		 * @return {Widget}
		 * */
		_getStepCardByIndex: function(index) {
			return this.stepItemContainer.getChildByIndex(index);
		},

		/**
		 * Get the corresponding step card widget by the page given
		 * @param {Widget} page
		 * @return {Widget}
		 * */
		_getStepCardByPage: function(page) {
			const pageIndex = this.getIndexOfPage(page);
			return this._getStepCardByIndex(pageIndex);
		},

		/**
		 * check if it's in the case of copying node, like "New From"
		 */
		_isCopyingNode: function() {
			const ac = this.getSourceController();
			return ac.isCopyingNode;
		},

		/**
		 * Select new page and resize dialog to apply new maximum bounds to view
		 * @param {Content} page
		 */
		_onChangePage: function(/*Content*/page) {
			this._updateWizardPage(page);
			this.tabsNode.selectChild(page);

			topic.publish("/csi/dialog/resize/required", true);
		},

		/**
		 * Populate the subtitle of the previous page based on the given form data
		 * @param {Widget} page
		 * */
		_populatePreviousSubtitle: function() {
			const targetPage = this.getSelectedPage();
			const targetPageIndex = this.getIndexOfPage(targetPage);
			const targetStepData = this.stepList[targetPageIndex];

			if (!targetPage || !targetPage.viewTab) {
				return;
			}

			const {viewTab} = targetPage;

			let {
				stepData,
				defView
			} = viewTab;

			const formData = defView.getFormData();
			const targetNodeType = defView.getTypeNode();
			const viewType = defView.getType();
			let names;

			if (!stepData && targetNodeType == StepData.WIZARD_IMAGE) {
				return;
			} else if (viewType == StepData.WIZARD_TABLE || viewType == StepData.WIZARD_GALLERY) {
				const nodeTypeOfView = viewTab.relRoot.getTargetType();
				names = formData
					.getSelectedNodes()
					.filter(node => node.$Type == nodeTypeOfView)
					.map(node => locale.getNodeReferenceName(node, this.cacheView));
			} else if (viewType == StepData.WIZARD_FORM) {
				// since the fields in the FormData include all the fields, so, use the fields on view instead
				names = defView.m_fields.filter(field => {
					const fieldType = field.m_typeControl;
					const isContentType = def.FIELD_FILTERING_SELECT || fieldType == def.FIELD_MULTI_SELECT || fieldType == def.FIELD_TEXT;

					// cover the single select, multiple select and textbox
					if (!field.bHidden && field.m_bRequired && isContentType) {
						const type = field.getType();
						const value = formData.getFieldValue(field);
						return xml.valueIsValid(value, type);
					}

					return false;
				}).map(field => {
					// cover the single select, multiple select and textbox
					return field.getStringValue();
				});
			}

			if (names) {
				names = this.onPopulatePreviousSubtitle(names);
				stepData = new StepData({
					type: viewType,
					enteredData: {
						names
					}
				});
			}

			// update the step data
			targetStepData.type = stepData.type;
			targetStepData.setEnteredData(stepData.getEnteredData());

			// update the widget
			const targetStepCard = this._getStepCardByIndex(targetPageIndex);
			targetStepCard.setEnteredItem(targetStepData);
		},

		_postView () {
			// summary: update actions after building view
			var dfd = this.inherited(arguments);

			if (this.isValidView()) {
				this.set("disabled", false);
			}

			return dfd;
		},

		/**
		 * Update the step data once the selected step changes
		 * @param {Widget} previousStepCardItem
		 * @param {Widget} nextStepCardItem
		 * */
		_updateStateOfStepDataOnNavigation: function(previousStepCardItem, nextStepCardItem) {
			if (!previousStepCardItem || !nextStepCardItem) {
				return;
			}
			const {stepList} = this;

			const previousIndex = previousStepCardItem.index;
			const nextIndex = nextStepCardItem.index;
			const previousStepData = stepList.find(stepData => (stepData.index == previousIndex));
			const nextStepData = stepList.find((stepData) => (stepData.index == nextIndex));
			const moveForward = nextIndex > previousIndex;

			if (moveForward) {
				previousStepData.state = previousStepData.PAST;
			} else {
				for (let i = nextIndex; i <= previousIndex; i++) {
					const tempStepData = stepList.find((stepData) => (stepData.index == i));
					tempStepData.state = tempStepData.FUTURE;
				}
			}

			nextStepData.state = nextStepData.PRESENT;
		},

		/**
		 * Reset the styling based on the state of this step
		 * */
		_updateStylingPerStep: function() {
			const {
				stepList
			} = this;

			stepList.forEach((stepData, i) => {
				const state = stepData.state;
				const currentStepItem = this._getStepCardByIndex(i);

				if (state == stepData.PAST) {
					currentStepItem.markStepPast();
				} else if (state == stepData.FUTURE) {
					currentStepItem.markStepFuture();
				} else {
					currentStepItem.markStepPresent();
				}
			});
		},

		/**
		 * Update wizard based on given page, also, update the step related information
		 * @param {Content} page
		 */
		_updateWizardPage: function(page) {
			const view = page.getView(this);
			this.scrollNode = view ? view.scrollNode : null;
			this.getSourceController().onWizardPageSelect(this, page);

			if (this.hideNumberedStep) {
				html.setVisible(this.introNode, false);
				return;
			}
			// update the details information
			const index = this.getIndexOfPage(page);
			const stepData = this.stepList[index];

			// if the wizard has some optional steps, since we calculate the page based on views, probably we can get to this case where we got 3 pages and only 2 steps,
			// two pages share the same title/subtitle, in this case, when switch between pages, the stepData could be null
			if (stepData) {
				this.setWizardIntroNode(stepData.detail);
			}


			// update step data and step item widget
			if (!this.stepItemContainer) {
				// not initialized yet
				return;
			}

			const currentStepCard = this._getStepCardByPage(this.getSelectedPage());
			const nextStepCard = this._getStepCardByPage(page);

			this._updateStateOfStepDataOnNavigation(currentStepCard, nextStepCard);
			this._updateStylingPerStep();
		}
	});
});